/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledTextLink, StyledIcon } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const TextLink = forwardRef((props, ref) => {
    const { children, weight = 'normal', icon, variant, size, iconPosition, title, 'data-testid': dataTestId, 'aria-label': ariaLabel, 'data-aue-type': dataAueType, 'data-aue-resource': dataAueRessource, 'data-aue-label': dataAueLabel, 'data-aue-prop': dataAueProp, 'data-aue-behavior': dataAueBehavior, 'data-aue-filter': dataAueFilter, 'data-aue-model': dataAueModel, role, margin, className, id, tabIndex, underline = true } = props;
    const baseProps = {
        children,
        'data-testid': dataTestId,
        'aria-label': ariaLabel,
        'data-aue-type': dataAueType,
        'data-aue-resource': dataAueRessource,
        'data-aue-label': dataAueLabel,
        'data-aue-prop': dataAueProp,
        'data-aue-behavior': dataAueBehavior,
        'data-aue-filter': dataAueFilter,
        'data-aue-model': dataAueModel,
        className,
        title,
        role,
        margin,
        ref,
        icon,
        id
    };
    const iconSize = size === 'md' ? 's' : 'xs';
    const iconElement = icon && (React.createElement(StyledIcon, { name: icon, size: iconSize, iconPosition: iconPosition, variant: variant }));
    const content = (React.createElement(React.Fragment, null,
        variant !== 'inline' && iconPosition === 'leading' && iconElement,
        children,
        (iconPosition === 'trailing' || variant === 'inline') && iconElement));
    if (hasHref(props)) {
        const { href, onClick, target, rel } = props;
        const textLinkAsLinkProps = {
            href,
            onClick,
            target,
            rel
        };
        if (variant === 'standalone') {
            return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsLinkProps, as: "a", size: size, variant: variant, iconPosition: iconPosition, tabIndex: tabIndex, underline: underline }, content));
        }
        return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsLinkProps, as: "a", size: size, variant: variant, tabIndex: tabIndex, weight: weight }, content));
    }
    const { disabled, onClick, type = 'button' } = props;
    const textLinkAsButtonProps = {
        onClick,
        type,
        disabled
    };
    if (variant === 'standalone') {
        return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsButtonProps, as: "button", size: size, variant: variant, iconPosition: iconPosition, tabIndex: tabIndex, underline: underline }, content));
    }
    return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsButtonProps, as: "button", size: size, variant: variant, weight: weight, tabIndex: tabIndex }, content));
});
TextLink.displayName = 'TextLink';
//# sourceMappingURL=index.js.map